import { createAsyncThunk } from "@reduxjs/toolkit";
import { db } from "../../../firebase/config";
import { TalesProgramma } from "../../../utils/types/TalesProgramma";

export const deleteProgramma = createAsyncThunk(
  "programma/delete",
  async (programma: TalesProgramma) => {
    try {
      const querySnapshot = await db
        .collection("programma")
        .where("title", "==", programma.title)
        .get();

      return querySnapshot.docs[0].ref.delete();
    } catch (e: any) {
      console.log(e);

      return Promise.reject(`Programma non eliminato, ${e.message}`);
    }
  },
);
